import { createContext } from 'react';
import { CreateIncidentReportInput } from '@/graphql/generated';

export type AddIncidentReportFormModalContextProps = {
  closeModal: () => void
  openModal: (reportData?: CreateIncidentReportInput) => void
  reportData: CreateIncidentReportInput | null
  isOpen: boolean
}

export const AddIncidentReportFormModalContext = createContext<AddIncidentReportFormModalContextProps | null>(null)
